import {
  changeSpouseIsSameAddress,
  setNextPage,
  submitAction,
  submitApplication,
  validateAllFieldsForPage
} from 'reg_redesign/actions';
import {
  debouncedValidateAction,
  validateAction,
  validateDate
} from 'sharedActions/sharedActions';
import { isFunction } from 'lodash';
import { replaceProps } from 'reg_redesign/helper';
import { SET_DATA, SET_ERROR } from 'helpers/Constants';
import checkRedirectAndSubmit from 'reg_redesign/checkRedirectAndSubmit';
import checkTurndownsAndSubmit from 'reg_redesign/checkTurndownsAndSubmit';
import React from 'react';
import RebrandTooltip from 'components/rebrand/RebrandTooltip';

export function mapStateToPropsNextButton(field) {
  return (state) => {
    const errors = validateAllFieldsForPage(field.props.page, state);
    const isEnabled = Object.values(errors).every((value) => {
      return value === '';
    });
    return {
      ...field.props,
      disabled: !isEnabled,
      loading: !!state.submitLoading || !!state.waitingForJukebox
    };
  };
}

export function mapDispatchDatePicker(field) {
  return (dispatch) => {
    return {
      onDatePickerChange: (val, minDate, maxDate) => {
        dispatch({ type: SET_DATA, payload: { [field.props.id]: val } });
        if (field.props.onDatePickerChange) {
          dispatch(
            field.props.onDatePickerChange(
              val,
              field.props.id,
              minDate,
              maxDate
            )
          );
        }
      },
      onTextFieldChange: (val, minDate, maxDate) => {
        dispatch({
          type: SET_DATA,
          payload: { [field.props.id]: val.slice(0, 10) }
        });
        if (field.props.onTextFieldChange) {
          dispatch(
            field.props.onTextFieldChange(val, field.props.id, minDate, maxDate)
          );
        }
      },
      onTouch: (val, minDate, maxDate) => {
        dispatch(validateDate(field.props.id, minDate, maxDate));
        if (field.props.onTouch) {
          dispatch(field.props.onTouch(val, field.props.id, minDate, maxDate));
        }
      },
      onBlur: (val, minDate, maxDate) => {
        dispatch(validateDate(field.props.id, minDate, maxDate));
        if (field.props.onBlur) {
          dispatch(field.props.onBlur(val, field.props.id, minDate, maxDate));
        }
      },
      onMount: (val, minDate, maxDate) => {
        if (field.props.onMount) {
          dispatch(field.props.onMount(val, field.props.id, minDate, maxDate));
        }
      }
    };
  };
}

export function mapDispatchIntroPage(field, navigate) {
  return (dispatch) => {
    return {
      onClick: () => {
        const handleContinue = (pageName) => {
          navigate(`/register/${pageName}${window.location.search}`);
        };
        dispatch(setNextPage(handleContinue));
      }
    };
  };
}

export function mapDispatchNextPage(field, navigate) {
  return (dispatch) => {
    function regularPageSubmit() {
      const handleContinue = (pageName) => {
        navigate(`/register/${pageName}${window.location.search}`);
      };
      const currentPage = window.location.pathname.split('/').pop();
      dispatch(submitAction(currentPage, handleContinue));
    }

    return {
      onClick: regularPageSubmit,
      onMouseDown: regularPageSubmit
    };
  };
}

export function sendSmartyUsageToHeap() {
  return (dispatch, getState) => {
    const state = getState();
    const metadata = state.addressEntryMetadata;
    const address = metadata?.address
      ? metadata.address
      : {
          lineOne: state.homeStreetAddress,
          lineTwo: state.secondaryAddress,
          city: state.city,
          state: state.state,
          zip: state.zip
        };

    window.postHeapAnalytic('track', `[smarty][submitted]`, {
      originationId: window.AppConfig?.origination_id,
      address: JSON.stringify(address),
      usageType: metadata?.entryMethod || 'prefilled'
    });
  };
}

export function sendAddressConfirmationToHeap() {
  return (dispatch, getState) => {
    const state = getState();

    window.postHeapAnalytic('track', `[address][confirmation]`, {
      productOwner: state.productOwner,
      type: state.type,
      value: state.isAddressConfirmed
    });
  };
}

export function mapDispatchNextPageWithTurndowns(field, navigate) {
  return (dispatch) => {
    function regularPageSubmit() {
      const handleContinue = (pageName) => {
        navigate(`/register/${pageName}${window.location.search}`);
      };

      dispatch(checkTurndownsAndSubmit(handleContinue));
      dispatch(sendSmartyUsageToHeap());
    }

    return {
      onClick: regularPageSubmit
    };
  };
}

export function mapDispatchNextPageWithRedirect(field, navigate) {
  return (dispatch) => {
    function regularPageSubmit() {
      const handleContinue = (pageName) => {
        navigate(`/register/${pageName}${window.location.search}`);
      };

      dispatch(checkRedirectAndSubmit(handleContinue));
    }

    return {
      onClick: regularPageSubmit
    };
  };
}

export function mapDispatchSubmitApplication() {
  return (dispatch) => {
    return {
      onClick: () => {
        dispatch(submitApplication());
      }
    };
  };
}

export function defaultMapDispatchToProps(field) {
  return (dispatch) => {
    return {
      onMount: (val, ...arg) => {
        if (field.props.onMount) {
          dispatch(field.props.onMount(val, field.props.id, ...arg));
        }
      },
      onChange: (val) => {
        dispatch({
          type: SET_DATA,
          payload: { [field.props.id]: val }
        });
        if (field.props.onChange) {
          dispatch(field.props.onChange(val, field.props.id));
        }
      },
      onTouch: (val) => {
        dispatch(validateAction(field.props.id));
        if (field.props.onTouch) {
          dispatch(field.props.onTouch(val, field.props.id));
        }
      },
      onBlur: (val) => {
        dispatch(validateAction(field.props.id));
        if (field.props.onBlur) {
          dispatch(field.props.onBlur(val, field.props.id));
        }
      }
    };
  };
}

export function mapDispatchToPropsEmail(field) {
  return (dispatch) => {
    return {
      onMount: (val) => {
        if (field.props.onMount) {
          dispatch(field.props.onMount(val, field.props.id, true));
        }
      },
      onChange: (val) => {
        dispatch({
          type: SET_DATA,
          payload: { [field.props.id]: val }
        });
        if (field.props.onChange) {
          dispatch(field.props.onChange(val, field.props.id, false));
        }
      }
    };
  };
}

export function mapDispatchButtonGroup(field) {
  return (dispatch) => {
    return {
      onClick: (val) => {
        dispatch({
          type: SET_DATA,
          payload: { [field.props.id]: val }
        });
        dispatch({
          type: SET_ERROR,
          payload: { [field.props.id]: '' }
        });
        if (isFunction(field.props.onClick)) {
          dispatch(field.props.onClick());
        }
      }
    };
  };
}

export function defaultMapStateToProps(field) {
  return (state) => ({
    value: state[field.props.id],
    error: state.errors[field.props.id],
    presetDisabled: state?.isDisabled?.[field.props.id],
    isVisible: state.fieldsToDisplay[field.props.id],
    additionalProp: state.additionalProps[field.props.id]
  });
}

export function mapStateTextDisplay(field) {
  return (state) => {
    let content;
    if (Array.isArray(field.textContent)) {
      content = field.textContent.map((ele) => {
        return replaceProps(ele, state);
      });
    } else {
      content = replaceProps(field.textContent, state);
    }

    if (field?.props?.id) {
      return {
        textToDisplay: content,
        isVisible: state.fieldsToDisplay[field.props.id]
      };
    }
    return {
      textToDisplay: content
    };
  };
}

export function mapStateLoanAmount(field) {
  return (state) => ({
    TooltipComponent: () => (
      <RebrandTooltip
        additionalStyle={{ marginTop: '0.25rem !important' }}
        text={`Please choose an amount between $${state.minLoanAmount} - $${state.maxLoanAmount}`}
      />
    ),
    isVisible: state.fieldsToDisplay[field.props.id],
    error: state.errors[field.props.id],
    value: state.loanAmount,
    label: window.AppConfig.is_line_of_credit
      ? 'Requested Credit Limit (optional)'
      : 'Loan Amount Requested (optional)'
  });
}

export function mapDispatchLoanAmount(field) {
  return (dispatch) => {
    return {
      onMount: (val, ...arg) => {
        if (field.props.onMount) {
          dispatch(field.props.onMount(val, field.props.id, ...arg));
        }
      },
      onChange: (val) => {
        dispatch({
          type: SET_DATA,
          payload: { [field.props.id]: val }
        });
        if (field.props.onChange) {
          dispatch(field.props.onChange(val, field.props.id));
        }
        dispatch(debouncedValidateAction(field.props.id));
      },
      onTouch: (val) => {
        dispatch(debouncedValidateAction(field.props.id));
        if (field.props.onTouch) {
          dispatch(field.props.onTouch(val, field.props.id));
        }
      },
      onBlur: (val) => {
        dispatch(debouncedValidateAction(field.props.id));
        if (field.props.onBlur) {
          dispatch(field.props.onBlur(val, field.props.id));
        }
      }
    };
  };
}

export function emptyMapStateToProps() {
  return () => ({});
}

export function mapStateToPropsCityStateZip(field) {
  return (state) => ({
    cityValue: state[field.props.cityId],
    cityError: state.errors[field.props.cityId],
    cityPresetDisabled: state?.isDisabled?.[field.props.cityId],
    cityIsVisible: state.fieldsToDisplay[field.props.cityId],
    cityAdditionalProp: state.additionalProps[field.props.cityId],

    stateValue: state[field.props.stateId],
    stateError: state.errors[field.props.stateId],
    statePresetDisabled: state?.isDisabled?.[field.props.stateId],
    stateIsVisible: state.fieldsToDisplay[field.props.stateId],
    stateAdditionalProp: state.additionalProps[field.props.stateId],

    zipValue: state[field.props.zipId],
    zipError: state.errors[field.props.zipId],
    zipPresetDisabled: state?.isDisabled?.[field.props.zipId],
    zipIsVisible: state.fieldsToDisplay[field.props.zipId],
    zipAdditionalProp: state.additionalProps[field.props.zipId]
  });
}

export function mapDispatchToPropsCityStateZip(field) {
  return (dispatch) => {
    return {
      cityOnMount: (val) => {
        if (field.props.cityOnMount) {
          dispatch(field.props.cityOnMount(val, field.props.cityId));
        }
      },
      zipOnMount: (val) => {
        if (field.props.zipOnMount) {
          dispatch(field.props.zipOnMount(val, field.props.zipId));
        }
      },
      cityOnChange: (val) => {
        dispatch({
          type: SET_DATA,
          payload: { [field.props.cityId]: val }
        });
        if (field.props.cityOnChange) {
          dispatch(field.props.cityOnChange(val, field.props.cityId));
        }
      },
      stateOnChange: (val) => {
        dispatch({
          type: SET_DATA,
          payload: { [field.props.stateId]: val }
        });
        dispatch(validateAction(field.props.stateId));
        if (field.props.stateOnChange) {
          dispatch(field.props.stateOnChange(val, field.props.stateId));
        }
      },
      zipOnChange: (val) => {
        dispatch({
          type: SET_DATA,
          payload: { [field.props.zipId]: val }
        });
        if (field.props.zipOnChange) {
          dispatch(field.props.zipOnChange(val, field.props.zipId));
        }
      },
      cityOnTouch: (val) => {
        dispatch(validateAction(field.props.cityId));
        if (field.props.cityOnTouch) {
          dispatch(field.props.cityOnTouch(val, field.props.cityId));
        }
      },
      zipOnTouch: (val) => {
        dispatch(validateAction(field.props.zipId));
        if (field.props.zipOnTouch) {
          dispatch(field.props.zipOnTouch(val, field.props.zipId));
        }
      },
      cityOnBlur: (val) => {
        dispatch(validateAction(field.props.cityId));
        if (field.props.cityOnBlur) {
          dispatch(field.props.cityOnBlur(val, field.props.cityId));
        }
      },
      stateOnBlur: (val) => {
        dispatch(validateAction(field.props.stateId));
        if (field.props.stateOnBlur) {
          dispatch(field.props.stateOnBlur(val, field.props.stateId));
        }
      },
      zipOnBlur: (val) => {
        dispatch(validateAction(field.props.zipId));
        if (field.props.zipOnBlur) {
          dispatch(field.props.zipOnBlur(val, field.props.zipId));
        }
      }
    };
  };
}

export function mapStateToPropsAddress(field) {
  return (state) => ({
    lineOneValue: state[field.props.lineOneId],
    lineOneError: state.errors[field.props.lineOneId],
    lineOnePresetDisabled: state?.isDisabled?.[field.props.lineOneId],
    lineOneAdditionalProp: state.additionalProps?.[field.props.lineOneId],

    lineTwoValue: state[field.props.lineTwoId],
    lineTwoError: state.errors[field.props.lineTwoId],
    lineTwoPresetDisabled: state?.isDisabled?.[field.props.lineTwoId],
    lineTwoAdditionalProp: state.additionalProps?.[field.props.lineTwoId],

    cityValue: state[field.props.cityId],
    cityError: state.errors[field.props.cityId],
    cityPresetDisabled: state?.isDisabled?.[field.props.cityId],
    cityAdditionalProp: state.additionalProps?.[field.props.cityId],

    stateValue: state[field.props.stateId],
    stateError: state.errors[field.props.stateId],
    statePresetDisabled: state?.isDisabled?.[field.props.stateId],
    stateAdditionalProp: state.additionalProps?.[field.props.stateId],

    zipValue: state[field.props.zipId],
    zipError: state.errors[field.props.zipId],
    zipPresetDisabled: state?.isDisabled?.[field.props.zipId],
    zipAdditionalProp: state.additionalProps?.[field.props.zipId]
  });
}

export function mapDispatchToPropsAddress(field) {
  return (dispatch) => {
    return {
      setAddressEntryMetadata: (val) => {
        dispatch({ type: SET_DATA, payload: { addressEntryMetadata: val } });
      },
      lineOneOnMount: (val) => {
        if (field.props.lineOneOnMount) {
          dispatch(field.props.lineOneOnMount(val, field.props.lineOneId));
        }
      },
      lineTwoOnMount: (val) => {
        if (field.props.lineTwoOnMount) {
          dispatch(field.props.lineTwoOnMount(val, field.props.lineTwoId));
        }
      },
      cityOnMount: (val) => {
        if (field.props.cityOnMount) {
          dispatch(field.props.cityOnMount(val, field.props.cityId));
        }
      },
      zipOnMount: (val) => {
        if (field.props.zipOnMount) {
          dispatch(field.props.zipOnMount(val, field.props.zipId));
        }
      },
      lineOneOnChange: (val) => {
        dispatch({
          type: SET_DATA,
          payload: { [field.props.lineOneId]: val }
        });
        if (field.props.lineOneOnChange) {
          dispatch(field.props.lineOneOnChange(val, field.props.lineOneId));
        }
      },
      lineTwoOnChange: (val) => {
        dispatch({
          type: SET_DATA,
          payload: { [field.props.lineTwoId]: val }
        });
        if (field.props.lineTwoOnChange) {
          dispatch(field.props.lineTwoOnChange(val, field.props.lineTwoId));
        }
      },
      cityOnChange: (val) => {
        dispatch({
          type: SET_DATA,
          payload: { [field.props.cityId]: val }
        });
        dispatch(validateAction(field.props.cityId));
        if (field.props.cityOnChange) {
          dispatch(field.props.cityOnChange(val, field.props.cityId));
        }
      },
      stateOnChange: (val) => {
        dispatch({
          type: SET_DATA,
          payload: { [field.props.stateId]: val }
        });
        dispatch(validateAction(field.props.stateId));
        if (field.props.stateId === 'state' && val !== 'WI') {
          dispatch({
            type: SET_DATA,
            payload: {
              maritalStatus: '',
              spouseFirstName: '',
              spouseLastName: '',
              spouseAddress: '',
              spouseCity: '',
              spouseState: '',
              spouseZip: ''
            }
          });
        }
        if (field.props.stateOnChange) {
          dispatch(field.props.stateOnChange(val, field.props.stateId));
        }
      },
      zipOnChange: (val) => {
        dispatch({
          type: SET_DATA,
          payload: { [field.props.zipId]: val }
        });
        dispatch(validateAction(field.props.zipId));
        if (field.props.zipOnChange) {
          dispatch(field.props.zipOnChange(val, field.props.zipId));
        }
      },
      lineOneOnTouch: (val) => {
        dispatch(validateAction(field.props.lineOneId));
        if (field.props.lineOneOnTouch) {
          dispatch(field.props.lineOneOnTouch(val, field.props.lineOneId));
        }
      },
      lineTwoOnTouch: (val) => {
        dispatch(validateAction(field.props.lineTwoId));
        if (field.props.lineTwoOnTouch) {
          dispatch(field.props.lineTwoOnTouch(val, field.props.lineTwoId));
        }
      },
      cityOnTouch: (val) => {
        dispatch(validateAction(field.props.cityId));
        if (field.props.cityOnTouch) {
          dispatch(field.props.cityOnTouch(val, field.props.cityId));
        }
      },
      zipOnTouch: (val) => {
        dispatch(validateAction(field.props.zipId));
        if (field.props.zipOnTouch) {
          dispatch(field.props.zipOnTouch(val, field.props.zipId));
        }
      },
      lineOneOnBlur: (val) => {
        dispatch(validateAction(field.props.lineOneId));
        if (field.props.lineOneOnBlur) {
          dispatch(field.props.lineOneOnBlur(val, field.props.lineOneId));
        }
      },
      lineTwoOnBlur: (val) => {
        dispatch(validateAction(field.props.lineTwoId));
        if (field.props.lineTwoOnBlur) {
          dispatch(field.props.lineTwoOnBlur(val, field.props.lineTwoId));
        }
      },
      cityOnBlur: (val) => {
        dispatch(validateAction(field.props.cityId));
        if (field.props.cityOnBlur) {
          dispatch(field.props.cityOnBlur(val, field.props.cityId));
        }
      },
      stateOnBlur: (val) => {
        dispatch(validateAction(field.props.stateId));
        if (field.props.stateOnBlur) {
          dispatch(field.props.stateOnBlur(val, field.props.stateId));
        }
      },
      zipOnBlur: (val) => {
        dispatch(validateAction(field.props.zipId));
        if (field.props.zipOnBlur) {
          dispatch(field.props.zipOnBlur(val, field.props.zipId));
        }
      }
    };
  };
}

export function mapDispatchToPropsIsSpouseSameAddress() {
  return (dispatch) => ({
    onChange: (val) => {
      dispatch(changeSpouseIsSameAddress(val));
    },
    onMount: (val) => {
      dispatch(changeSpouseIsSameAddress(val));
    }
  });
}
export function passwordMapDispatchToProps(field) {
  return (dispatch) => {
    return {
      onMount: (val, validationText, touched) => {
        if (field.props.onMount) {
          dispatch(field.props.onMount(val, validationText, touched));
        }
      },
      onChange: (val, validationText, touched) => {
        dispatch({
          type: SET_DATA,
          payload: { [field.props.id]: val }
        });
        dispatch(validateAction(field.props.id));
        if (field.props.onChange) {
          dispatch(field.props.onChange(val, validationText, touched));
        }
      }
    };
  };
}
